module.exports = __webpack_public_path__ + "static/media/1012504949-preview.c19cb808.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/1012504949-preview.mp4
// module id = 1813
// module chunks = 0